import remotesConfig from 'remotesConfig'
import uiitemsubmissionMfeConfig from 'uiitemsubmissionMfeConfig'
import injectWindowVariables from '@ve/module-federation/injectWindowVariables'
import injectScripts from '@ve/module-federation/injectScripts'
if (uiitemsubmissionMfeConfig?.maintenance?.enabled) {
  injectWindowVariables(remotesConfig)
  import('./bootstrap')
} else {
  injectWindowVariables(remotesConfig)
  injectScripts(remotesConfig)
  import('./bootstrap')
}
export {}
